import './Feedback.scss';

import postData from '../../requests/script';
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Link } from 'react-router-dom';
import Loader from '../Loader/Loader';

function Feedback({ previousPath, nextPath, currentPath, answer1, answer2, answer3 }) {
    const [isChecked, setIsChecked] = useState(false);
    const onChecked = (event) => {
        setIsChecked(!isChecked);

    };
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");

    const onFeedback = (event) => {
        event.preventDefault();

        postData("https://www.spb.tfprint.ru/new-kviz-2023/build/api/main.php", JSON.stringify({
            "name": name,
            "email": email
        }));
        console.log(JSON.stringify({
            "name": name,
            "email": email
        }))
    };
    const [button, setButton] = useState(0);
    useEffect(() => {
        if (isChecked === true) {
            setButton((
                <Button variant="primary" type="submit" onClick={onFeedback}>
                    Отправить
                </Button>
            ))
        } else {
            setButton((
                <Button variant="primary" type="submit" disabled>
                    Отправить
                </Button>
            ))
        }
    }, [isChecked]);
    return (
        <div className='feedback'>
            {/* <h2>Оставте свои данные и мы свяжемся с вами</h2> */}
            <div className='feedback__forms'>
                <div className='feedback__feedback-form'>
                    <h5>Оставте свои данные и посмотрите список подходящих принтеров</h5>
                    <Form>
                        <Form.Group className="mb-3" >
                            <Form.Label>Имя</Form.Label>
                            <Form.Control type="text" placeholder="Введите имя" onChange={(event) => {setName(event.target.value)}}/>
                        </Form.Group>

                        <Form.Group className="mb-3" >
                            <Form.Label>Почта</Form.Label>
                            <Form.Control type="email" placeholder="Введите почту" onChange={(event) => {setEmail(event.target.value)}}/>
                        </Form.Group>
                        <Form.Check // prettier-ignore
                            type="switch"
                            id="custom-switch"
                            label={<a style={{ textDecoration: "none", fontSize: 14 + "px" }} href='https://www.spb.tfprint.ru/agreement.php'>Согласие на обработку персональных данных</a>}
                            onClick={onChecked}

                        />
                        {button}
                    </Form>
                    <br />
                </div>
                {/*  <div className='feedback__download-form'>
                     <h5>Скайчать список подходящих принтеров</h5>
                     
                 </div> */}
            </div>
            <div className='feedback__footer'>
                <Link to={previousPath} className='main__button button' style={{ textDecoration: "none", backgroundColor: "gray" }} >Назад</Link>
                <Link to={nextPath} className='main__button button' style={{ textDecoration: "none" }} >Далее</Link>
            </div>
            <Loader />


        </div>
    );
}

export default Feedback;